import React from "react";
import "../styles/AllCatagoryDescription.css"
const AllCatagoryDescription = () => {
  return (
    <div >
      <div className="descriptionDiv" style={{textAlign: "left"}}>
        <div >
          <h3 className="catagoryHeading">Shop Safely And Worry-Free On PharmEasy</h3>
          <p className="catagoryTexts">
            PharmEasy is a renowned name in the online shopping of Over The
            Counter or healthcare products and other daily essentials. Ordering
            online on PharmEasy is convenient, fast and hassle-free; you can
            avoid the annoyance of queuing up at your local pharmacy and also
            avail of huge discounts of up to 80% OFF. Purchasing the healthcare
            requirements such as medical devices and nutritional supplements
            that you need will no longer burn a hole in your pocket. At
            PharmEasy, youare sure to find everything that you need because we
            have products across all healthcare categories.
          </p>
        </div>
        <div className="listDiv">
          <h3 className="catagoryHeading">Why choose PharmEasy?</h3>
          <p className="catagoryTexts">
            <ul>
              <li>8400+ Brands</li>
              <li>35K products in our stock</li>
              <li>Delivery to 22000+ pin codes</li>
              <li>Delivered to 50 lakh+ families</li>
              <li>Over 2M customers served</li>
            </ul>
          </p>
        </div>
        <div >
          <h3 className="catagoryHeading">Our most popular categories:</h3>
          <p className="catagoryTexts">
            We have a range of categories and products, some which are:
          </p>
        </div>
        <div >
          <h3 className="catagoryHeading">Devices</h3>
          <p className="catagoryTexts">
            With the pandemic upending our lives, we have all realized that
            there are some medical devices that we need to keep in our homes
            such as Oximeter, Thermometer, Inhaler, Blood pressure monitor,
            Glucometer.
          </p>
        </div>
        <div >
          <h3 className="catagoryHeading">Personal care</h3>
          <p className="catagoryTexts">
            Personal care products can include a wide range of products such as
            Bath products, , Skincare essentials, Razor blades, Toothpaste and
            toothbrush, Wet wipes, Lip balm, Face masks, Hand sanitizer, etc.
          </p>
        </div>
        <div >
          <h3 className="catagoryHeading">Nutrition and fitness supplements</h3>
          <p className="catagoryTexts">
            To give your health a helping hand, you can order a wide variety of
            health supplements including Health drinks, Nutritional powder,
            Nutrition tablets/capsules.
          </p>
        </div>
        <div >
          <h3 className="catagoryHeading">Ayurvedic care</h3>
          <p className="catagoryTexts">
            Place your trust in the goodness of natural and organic ayurvedic
            products for an all-around healthy mind and body. There’s plenty to
            choose from such as Aloe vera juice, Moringa capsules, Garlic
            capsules.
          </p>
        </div>
        <div >
          <h3 className="catagoryHeading">Home care</h3>
          <p className="catagoryTexts">
            Home care products are things you need every day such as
            disinfectant spray, phenyl, dishwashing liquid, etc. Get them all at
            spectacular discounts on PharmEasy.
          </p>
        </div>
        <div className="catagoryTexts9">
          <h3 className="catagoryHeading">Baby and mom care</h3>
          <p className="catagoryTexts">
            PharmEasy also has an impressive range of baby and mom care products
            including Diapers, Baby bath products, Infant formula food, Mother’s
            health drinks, Diaper rash creams, Baby wipes.
          </p>
        </div>
        <div >
          <h3 className="catagoryHeading">Our top brands:</h3>
          <p className="catagoryTexts">
            Get products from the most famous and trusted brands including
            Accu-chek, Dettol, Horlicks, Baidyanath, Sebamed.
          </p>
        </div>
        <div >
          <h3 className="catagoryHeading">You are safe with PharmEasy:</h3>
          <p className="catagoryTexts">
            Given the times, we are taking all precautions to ensure that we
            keep everyone safe - our customers and the people we work with.
          </p>
        </div>
        <div className="listDiv" >
          <h3 className="catagoryHeading">We ensure</h3>
          <p className="catagoryTexts">
            <ul>
              <li>Regular sanitization of our premises and warehouses</li>
              <li>Temperature checks of our employees and delivery partners</li>
              <li>No-contact door-step delivery</li>
              <li>Sanitized packaging</li>
            </ul>
          </p>
        </div>
        <div >
          <h3 className="catagoryHeading">Youe safety is our priority</h3>
          <p className="catagoryTexts">
            Stay safe at home and shop at your convenience from PharmEasy. All
            you have to do is place your order and we will try to deliver it at
            the earliest.
          </p>
        </div>
      </div>
    </div>
  );
};

export default AllCatagoryDescription;
